import { render, staticRenderFns } from "./New_Applications.vue?vue&type=template&id=2a5eb806&scoped=true"
import script from "./New_Applications.vue?vue&type=script&setup=true&lang=js"
export * from "./New_Applications.vue?vue&type=script&setup=true&lang=js"
import style0 from "./New_Applications.vue?vue&type=style&index=0&id=2a5eb806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5eb806",
  null
  
)

export default component.exports